import AccessTimeIcon from "@mui/icons-material/AccessTime";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Button, Modal, Skeleton, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import SurveyInfoModel from "../../Models/Survey/SurveyInfoModel";
import SurveyService from "../../Services/SurveyService";

type Props = {
  surveyTypeId: string;
};

export default function SurveyInfo(props: Props) {
  const { t, i18n } = useTranslation("survey");

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [loading, setLoading] = useState<boolean>(false);
  const surveyService = useMemo(() => new SurveyService(), []);
  const [surveyInfo, setSurveyInfo] = useState<SurveyInfoModel>();

  useEffect(() => {
    if (open) {
      loadSurveyInfo();
    }
  }, [open]);

  function loadSurveyInfo() {
    setLoading(true);
    if (props.surveyTypeId) {
      surveyService
        .getInfo(props.surveyTypeId, i18n.language)
        .then((result) => {
          if (result === null) {
            toast.error(t("Geen informatie gevonden voor deze vragenlijst."));
          } else {
            setSurveyInfo(result);
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(
            t("Fout bij ophalen van info voor vragenlijst voorwaarden.")
          );
        })
        .finally(() => {});
    }
  }

  return <>{getFormFields()}</>;

  function getFormFields() {
    return (
      <div>
        <InfoOutlinedIcon onClick={handleOpen} />
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute" as "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "100%", sm: 600 },
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
            }}
          >
            {!loading && surveyInfo ? (
              <>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  {surveyInfo?.name}
                </Typography>
                <Typography id="modal-modal-description">
                  <AccessTimeIcon /> {surveyInfo?.expectedTime} {t("minuten.")}
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  {surveyInfo?.info}
                </Typography>
              </>
            ) : (
              <>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "1rem" }}
                    width={"50%"}
                  />
                </Typography>
                <Typography id="modal-modal-description">
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "1rem" }}
                    width={"25%"}
                  />
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "1rem" }}
                    width={"35%"}
                  />
                </Typography>
              </>
            )}

            <Button
              className="m-2 float-end"
              variant="contained"
              onClick={handleClose}
            >
              {t("Sluiten")}
            </Button>
          </Box>
        </Modal>
      </div>
    );
  }
}
